import type { AgentFilter } from "@agent/domain/models/agent.model";
import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";
@injectable()
export class AgentFilterViewmodel extends BaseViewModel {
    @observable
    filters: AgentFilter = {};

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    setFilters(updatedFilters: Partial<AgentFilter>): void {
        runInAction(() => {
            this.filters = { ...this.filters, ...updatedFilters };
        });
    }

    @action
    getFilters(): AgentFilter {
        return {
            name: this.filters.name,
            category: this.filters.category,
            pathogenType: this.filters.pathogenType,
            cropTypeId: this.filters.cropTypeId,
        };
    }
}
